// Tiny CSV export. UTF-8 BOM + semicolon separator so Excel/Numbers open it
// cleanly without import wizards. Cyrillic stays readable.
//
// Usage:
//   exportToCsv("payments-2026-04.csv", [
//     { Date: "2026-04-01", Amount: 1200, Currency: "UAH" },
//     ...
//   ]);
//
// Or pass explicit columns to control order/headers:
//   exportToCsv("payments-2026-04.csv", rows, [
//     { key: "date", header: "Date" },
//     { key: "amount", header: "Amount" },
//   ]);

const BOM = "﻿";
const SEP = ";";

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  let s = String(value);
  // Normalize newlines and CR so the CSV row stays one line.
  s = s.replace(/\r\n/g, " ").replace(/[\r\n]+/g, " ");
  if (s.includes(SEP) || s.includes('"')) {
    s = '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

export function buildCsv(rows, columns, options = {}) {
  if (!Array.isArray(rows) || rows.length === 0) return BOM;
  let cols = columns;
  if (!cols) {
    const keys = new Set();
    rows.forEach((r) => Object.keys(r || {}).forEach((k) => keys.add(k)));
    cols = Array.from(keys).map((k) => ({ key: k, header: k }));
  }
  const headerLine = cols.map((c) => escapeCell(c.header ?? c.key)).join(SEP);
  const lines = rows.map((row) =>
    cols.map((c) => escapeCell(row?.[c.key])).join(SEP)
  );
  // Optional preamble (e.g. "All amounts converted to USD @ 41.5 UAH/USD on 2026-05-20").
  // Renders as a single one-cell row above the table so Excel keeps it visible
  // but column widths don't break.
  const preamble = options.preamble ? [escapeCell(options.preamble), ""] : [];
  return BOM + [...preamble, headerLine, ...lines].join("\r\n");
}

export function exportToCsv(filename, rows, columns, options = {}) {
  const csv = buildCsv(rows, columns, options);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Free up the object URL after a tick — some browsers need the click to
  // resolve before revoke.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

// Build a sensible filename like "other-expenses-2026-05-07.csv"
export function timestampedName(prefix, ext = "csv") {
  const today = new Date().toISOString().slice(0, 10);
  return `${prefix}-${today}.${ext}`;
}
